import { Box } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { SettingsDangerZoneRow } from "~/components/settings/DangerZoneWrapper";
import { REMOVE_BIN_CONFIRMATION_PHRASE } from "~/features/preview/bins/binSettings.types";

import { RemoveBinModal } from "./RemoveBinModal";

export function RemoveBinDangerZone() {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmationInput, setConfirmationInput] = useState("");

  const hint = t("remove bin dev hint");

  const canOpenModal =
    confirmationInput.trim() === REMOVE_BIN_CONFIRMATION_PHRASE;

  const handleOpenModal = () => {
    if (!canOpenModal) return;
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setConfirmationInput("");
  };

  return (
    <Box component="section" aria-label={t("remove bin")}>
      <SettingsDangerZoneRow
        title={t("remove bin")}
        hint={hint}
        confirmationPhrase={REMOVE_BIN_CONFIRMATION_PHRASE}
        confirmationValue={confirmationInput}
        onConfirmationChange={setConfirmationInput}
        actionLabel={t("open remove bin tool")}
        onAction={handleOpenModal}
        actionDisabled={!canOpenModal}
      />

      <RemoveBinModal open={modalOpen} onClose={handleCloseModal} />
    </Box>
  );
}
